export default {"src":"/_next/static/media/notification.735262f3.svg","height":94,"width":95};